import React from "react";
import Spinner from "@src/components/atoms/spinner/spinner";
import {
  CrossNameSpaceOrganziation,
  OrganizationType,
} from "@src/types/namespace-configuration";
import styles from "./organizations-table-admin-panel.module.scss";
import { useOrganizationsTableAdminPanelHook } from "@src/components/organisms/organizations-table-admin-panel/use-organizations-table-admin-panel-hook";

const cssClassName = "organizations-table-admin-panel";

const organizationTypeCodes: Record<
  Exclude<OrganizationType, "other">,
  string
> = {
  factory: "FAC",
  distributor: "DIS",
  OEM: "OEM",
  support: "SUP",
};

interface OrganizationsTableAdminPanelProps {
  isLoading: boolean;
  organizations: CrossNameSpaceOrganziation[];
}

const OrganizationsTableAdminPanel = ({
  isLoading,
  organizations,
}: OrganizationsTableAdminPanelProps) => {
  const { organizationRows, texts } =
    useOrganizationsTableAdminPanelHook(organizations);

  return (
    <div className={styles[cssClassName]}>
      {!isLoading && organizationRows.length === 0 ? (
        <div className={styles[`${cssClassName}__empty-state`]}>
          {texts.noOrganizations}
        </div>
      ) : (
        <div className={styles[`${cssClassName}__list`]}>
          <table
            aria-busy={isLoading}
            className={styles[`${cssClassName}__table`]}
          >
            <thead>
              <tr className={styles[`${cssClassName}__header`]}>
                <th scope="col">{texts.typeHeader}</th>
                <th scope="col">{texts.nameHeader}</th>
              </tr>
            </thead>
            <tbody className={styles[`${cssClassName}__body`]}>
              {organizationRows.map((organization) => (
                <tr
                  className={styles[`${cssClassName}__row`]}
                  key={organization.key}
                >
                  <td
                    className={styles[`${cssClassName}__type`]}
                    data-type={organization.dataType}
                  >
                    {organization.typeIcon && (
                      <img
                        alt=""
                        className={styles[`${cssClassName}__type-icon`]}
                        src={organization.typeIcon}
                      />
                    )}
                    <span>
                      {organization.dataType === "other"
                        ? texts.otherOrganizationType
                        : organizationTypeCodes[organization.dataType]}
                    </span>
                  </td>
                  <td className={styles[`${cssClassName}__name`]}>
                    {organization.name}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {isLoading && (
        <div className={styles[`${cssClassName}__loader-wrapper`]}>
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default OrganizationsTableAdminPanel;
